import * as React from 'react';

import 'css!bundles/phoenix/components/__styles__/ProgressBar';

type Props = {
  width?: string;
  height?: string;
  percentComplete?: number;
};

class ProgressBar extends React.Component<Props> {
  static defaultProps = {
    width: '200px',
    height: '15px',
    percentComplete: 0,
  };

  render() {
    const { height, width, percentComplete } = this.props;

    return (
      <div className="rc-ProgressBar" style={{ width, height }} data-testid="progress-bar">
        <div className="bgcolor-primary" style={{ width: `${percentComplete}%`, height }} />
      </div>
    );
  }
}

export default ProgressBar;
